export default "__VITE_ASSET__DYGDgAqT__"